import useValidation from '@/composables/useValidation.js'
const { vruleFieldRequired, vruleSelectRequired, vruleValidEmailRequired, vruleValidPhoneRequired } = useValidation()
/**
 * Validation Mixin for input fields
 * Note: Vuetify native, not vee-validate as used in other places
 */
const validationMixin = {
  data: function () {
    return {
      vruleFieldRequired,
      vruleSelectRequired,
      vruleValidEmailRequired,
      vruleValidPhoneRequired
    }
  }
}

export default validationMixin
